import { FC, memo, ReactNode } from "react";
import type { StockListingUILabels } from "../../../interfaces/StockListingTableAEM.interface";

export interface StockFiltersProps {
  /** Whether to show the filter sidebar */
  showFilter: boolean;
  /** Filter component to render */
  filterComponent?: ReactNode;
  /** AEM UI labels */
  uiLabels?: StockListingUILabels;
}

const StockFilters: FC<StockFiltersProps> = memo(({ showFilter, filterComponent }) => {
  if (!showFilter || !filterComponent) {
    return  <aside className="hidden lg:block box-border w-[16.5%] shrink-0 leading-[19.2px] m-0 [unicode-bidi:isolate]  " />;
  }

  return (
    <aside className="hidden lg:block box-border w-[16.5%] shrink-0 leading-[19.2px] m-0 [unicode-bidi:isolate]">
      {filterComponent}
    </aside>
  );
});

StockFilters.displayName = "StockFilters";

export default StockFilters;

